import { WEEKDAYS } from '@workalizer/shared/config';
export var communicationByWeekdays = function (input) {
    return [
        {
            weekday: WEEKDAYS[0],
            previousPeriod: {
                meetingsDuration: 7200,
                docsDuration: 10080,
                chatDuration: 22440,
                gmailDuration: 5400,
                meetingsEventCount: 2,
                docsEventCount: 14,
                chatEventCount: 132,
                gmailEventCount: 18
            },
            currentPeriod: {
                meetingsDuration: 10800,
                docsDuration: 12600,
                chatDuration: 25200,
                gmailDuration: 6000,
                meetingsEventCount: 3,
                docsEventCount: 18,
                chatEventCount: 140,
                gmailEventCount: 20
            },
            team: {
                meetingsDuration: 9000,
                docsDuration: 11160,
                chatDuration: 23760,
                gmailDuration: 5700,
                meetingsEventCount: 2,
                docsEventCount: 16,
                chatEventCount: 128,
                gmailEventCount: 19
            }
        },
        {
            weekday: WEEKDAYS[1],
            previousPeriod: {
                meetingsDuration: 8400,
                docsDuration: 11520,
                chatDuration: 23920,
                gmailDuration: 5760,
                meetingsEventCount: 3,
                docsEventCount: 16,
                chatEventCount: 141,
                gmailEventCount: 19
            },
            currentPeriod: {
                meetingsDuration: 12000,
                docsDuration: 15120,
                chatDuration: 26880,
                gmailDuration: 6480,
                meetingsEventCount: 4,
                docsEventCount: 21,
                chatEventCount: 155,
                gmailEventCount: 22
            },
            team: {
                meetingsDuration: 10200,
                docsDuration: 13320,
                chatDuration: 25440,
                gmailDuration: 6120,
                meetingsEventCount: 3,
                docsEventCount: 18,
                chatEventCount: 142,
                gmailEventCount: 20
            }
        },
        {
            weekday: WEEKDAYS[2],
            previousPeriod: {
                meetingsDuration: 9600,
                docsDuration: 13680,
                chatDuration: 25920,
                gmailDuration: 6240,
                meetingsEventCount: 3,
                docsEventCount: 19,
                chatEventCount: 152,
                gmailEventCount: 21
            },
            currentPeriod: {
                meetingsDuration: 13200,
                docsDuration: 16200,
                chatDuration: 28800,
                gmailDuration: 6960,
                meetingsEventCount: 4,
                docsEventCount: 22,
                chatEventCount: 166,
                gmailEventCount: 23
            },
            team: {
                meetingsDuration: 11400,
                docsDuration: 14760,
                chatDuration: 27360,
                gmailDuration: 6600,
                meetingsEventCount: 4,
                docsEventCount: 20,
                chatEventCount: 158,
                gmailEventCount: 22
            }
        },
        {
            weekday: WEEKDAYS[3],
            previousPeriod: {
                meetingsDuration: 7800,
                docsDuration: 10800,
                chatDuration: 23040,
                gmailDuration: 5520,
                meetingsEventCount: 2,
                docsEventCount: 15,
                chatEventCount: 135,
                gmailEventCount: 18
            },
            currentPeriod: {
                meetingsDuration: 11400,
                docsDuration: 14040,
                chatDuration: 25920,
                gmailDuration: 6240,
                meetingsEventCount: 3,
                docsEventCount: 20,
                chatEventCount: 148,
                gmailEventCount: 21
            },
            team: {
                meetingsDuration: 9600,
                docsDuration: 12240,
                chatDuration: 24000,
                gmailDuration: 5880,
                meetingsEventCount: 3,
                docsEventCount: 17,
                chatEventCount: 138,
                gmailEventCount: 19
            }
        },
        {
            weekday: WEEKDAYS[4],
            previousPeriod: {
                meetingsDuration: 6600,
                docsDuration: 9000,
                chatDuration: 21120,
                gmailDuration: 5040,
                meetingsEventCount: 2,
                docsEventCount: 12,
                chatEventCount: 124,
                gmailEventCount: 17
            },
            currentPeriod: {
                meetingsDuration: 9600,
                docsDuration: 11880,
                chatDuration: 24000,
                gmailDuration: 5760,
                meetingsEventCount: 3,
                docsEventCount: 17,
                chatEventCount: 142,
                gmailEventCount: 19
            },
            team: {
                meetingsDuration: 7800,
                docsDuration: 10440,
                chatDuration: 22320,
                gmailDuration: 5400,
                meetingsEventCount: 2,
                docsEventCount: 14,
                chatEventCount: 128,
                gmailEventCount: 18
            }
        },
        {
            weekday: WEEKDAYS[5],
            previousPeriod: {
                meetingsDuration: 1800,
                docsDuration: 2880,
                chatDuration: 7560,
                gmailDuration: 1800,
                meetingsEventCount: 1,
                docsEventCount: 4,
                chatEventCount: 45,
                gmailEventCount: 6
            },
            currentPeriod: {
                meetingsDuration: 3000,
                docsDuration: 4320,
                chatDuration: 8640,
                gmailDuration: 2100,
                meetingsEventCount: 1,
                docsEventCount: 6,
                chatEventCount: 52,
                gmailEventCount: 7
            },
            team: {
                meetingsDuration: 2400,
                docsDuration: 3600,
                chatDuration: 7920,
                gmailDuration: 1950,
                meetingsEventCount: 1,
                docsEventCount: 5,
                chatEventCount: 48,
                gmailEventCount: 6
            }
        },
        {
            weekday: WEEKDAYS[6],
            previousPeriod: {
                meetingsDuration: 1200,
                docsDuration: 2160,
                chatDuration: 6480,
                gmailDuration: 1500,
                meetingsEventCount: 1,
                docsEventCount: 3,
                chatEventCount: 38,
                gmailEventCount: 5
            },
            currentPeriod: {
                meetingsDuration: 1800,
                docsDuration: 3240,
                chatDuration: 7200,
                gmailDuration: 1800,
                meetingsEventCount: 1,
                docsEventCount: 4,
                chatEventCount: 44,
                gmailEventCount: 6
            },
            team: {
                meetingsDuration: 1500,
                docsDuration: 2520,
                chatDuration: 6840,
                gmailDuration: 1650,
                meetingsEventCount: 1,
                docsEventCount: 3,
                chatEventCount: 40,
                gmailEventCount: 5
            }
        }
    ];
};
